// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1IaWH","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2zFqV"};